import PerBonusesPage from './PerBonusesPage';

export default PerBonusesPage;
